import React, { useState, useEffect } from "react";
import "./AdmBooKConfigurations.css";
import { ApiUrl } from "../../../ApiUrl";

const LibrarySettings = () => {
  const [settings, setSettings] = useState({
    penaltyEnabled: " ",
    daysToReturn: " ",
    penaltyPerDay: " ",
    sendMessageEnabled: " ",
    daysPriorMessage: " ",
    maxBooksStudent: " ",
    maxBooksTeacher: " ",
  });

  useEffect(() => {
    fetchLibrarySettings();
  }, []);

  const fetchLibrarySettings = async () => {
    try {
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      const response = await fetch(
        `${ApiUrl.apiurl}LIBRARYBOOK/LibraryParameterConfigurationList/?org_id=${orgId}&branch_id=${branchId}`
      );
      const result = await response.json();

      if (result.message === "success" && result.data) {
        setSettings({
          penaltyEnabled:
            result.data.ENABLE_LIBRARY_PENALITY === "YES" ? "Yes" : "No",
          daysToReturn: result.data.LIBRARY_BOOK_RETURN_DAYS,
          penaltyPerDay: result.data.LIBRARY_PENALITY_PER_DAY,
          sendMessageEnabled:
            result.data.LIBRARY_BOOK_RETURN_MESSAGE_SEND === "YES"
              ? "Yes"
              : "No",
          daysPriorMessage: result.data.LIBRARY_BOOK_RETURN_MESSAGE_DAYS_PRIOR,
          maxBooksStudent: result.data.MAX_BOOKS_ISSUED_STUDENT,
          maxBooksTeacher: result.data.MAX_BOOKS_ISSUED_TEACHER,
        });
      }
    } catch (error) {
      console.error("Error fetching library settings:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings({ ...settings, [name]: value });
  };

  const handleSave = async () => {
    try {
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      const updatedData = {
        ENABLE_LIBRARY_PENALITY:
          settings.penaltyEnabled === "Yes" ? "YES" : "NO",
        LIBRARY_BOOK_RETURN_DAYS: settings.daysToReturn,
        LIBRARY_PENALITY_PER_DAY: settings.penaltyPerDay,
        LIBRARY_BOOK_RETURN_MESSAGE_SEND:
          settings.sendMessageEnabled === "Yes" ? "YES" : "NO",
        LIBRARY_BOOK_RETURN_MESSAGE_DAYS_PRIOR: settings.daysPriorMessage,
        MAX_BOOKS_ISSUED_STUDENT: settings.maxBooksStudent,
        MAX_BOOKS_ISSUED_TEACHER: settings.maxBooksTeacher,
        org_id: orgId,
        branch_id: branchId,
      };

      const response = await fetch(
        `${ApiUrl.apiurl}LIBRARYBOOK/LibraryParameterConfigurationUpdate/`,
        {
          method: "PUT", // or "PATCH"
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        }
      );

      const result = await response.json();

      if (result.message === "success") {
        alert("Library settings updated successfully!");
        fetchLibrarySettings(); // Refresh settings after update
      } else {
        alert("Failed to update settings. Please try again.");
      }
    } catch (error) {
      console.error("Error updating library settings:", error);
    }
  };

  // return (
  //   <div className="library-settings-container">
  //     <h2 className="library-title">LIBRARY SETTINGS</h2>
  //     <div className="library-settings-box">
  //       <h3 className="config-title">Configurations</h3>

  //       <div className="settings-section">
  //         <label className="settings-label">
  //           Enable Penalty on Return after Due Date
  //         </label>
  //         <div className="radio-group">
  //           <input
  //             type="radio"
  //             name="penaltyEnabled"
  //             value="Yes"
  //             checked={settings.penaltyEnabled === "Yes"}
  //             onChange={handleChange}
  //           />{" "}
  //           Yes
  //           <input
  //             type="radio"
  //             name="penaltyEnabled"
  //             value="No"
  //             checked={settings.penaltyEnabled === "No"}
  //             onChange={handleChange}
  //           />{" "}
  //           No
  //         </div>
  //       </div>

  //       <div className="settings-section">
  //         <label className="settings-label">
  //           Number of Days to Return Book *
  //         </label>
  //         <input
  //           type="number"
  //           className="input-field"
  //           name="daysToReturn"
  //           value={settings.daysToReturn}
  //           onChange={handleChange}
  //         />
  //       </div>

  //       <div className="settings-section">
  //         <label className="settings-label">Penalty per day *</label>
  //         <input
  //           type="number"
  //           className="input-field"
  //           name="penaltyPerDay"
  //           value={settings.penaltyPerDay}
  //           onChange={handleChange}
  //         />
  //       </div>

  //       <div className="settings-section">
  //         <label className="settings-label">
  //           Enable Send Message for Book Return Due Date
  //         </label>
  //         <div className="radio-group">
  //           <input
  //             type="radio"
  //             name="sendMessageEnabled"
  //             value="Yes"
  //             checked={settings.sendMessageEnabled === "Yes"}
  //             onChange={handleChange}
  //           />{" "}
  //           Yes
  //           <input
  //             type="radio"
  //             name="sendMessageEnabled"
  //             value="No"
  //             checked={settings.sendMessageEnabled === "No"}
  //             onChange={handleChange}
  //           />{" "}
  //           No
  //         </div>
  //       </div>

  //       <div className="settings-section">
  //         <label className="settings-label">
  //           Number Of Days prior to Send Message *
  //         </label>
  //         <input
  //           type="number"
  //           className="input-field"
  //           name="daysPriorMessage"
  //           value={settings.daysPriorMessage}
  //           onChange={handleChange}
  //         />
  //       </div>

  //       <div className="settings-section">
  //         <label className="settings-label">
  //           Max. Books Allowed to be Issued to Student *
  //         </label>
  //         <input
  //           type="number"
  //           className="input-field"
  //           name="maxBooksStudent"
  //           value={settings.maxBooksStudent}
  //           onChange={handleChange}
  //         />
  //       </div>

  //       <div className="settings-section">
  //         <label className="settings-label">
  //           Max. Books Allowed to be Issued to Teacher *
  //         </label>
  //         <input
  //           type="number"
  //           className="input-field"
  //           name="maxBooksTeacher"
  //           value={settings.maxBooksTeacher}
  //           onChange={handleChange}
  //         />
  //       </div>

  //       <button className="save-button" onClick={handleSave}>
  //         Save
  //       </button>
  //     </div>
  //   </div>
  // );

  return (
    <div className="library-settings-container">
      <h2 className="library-title">LIBRARY SETTINGS</h2>
      <div className="library-settings-box">
        <h3 className="config-title">Configurations</h3>
        <div className="settings-grid">
          {/* Left Column - Labels */}
          <div className="settings-labels">
            <label>Enable Penalty on Return after Due Date</label>
            <label>Number of Days to Return Book </label>
            <label>Penalty per day</label>
            <label>Enable Send Message for Book Return Due Date</label>
            <label>Number Of Days prior to Send Message </label>
            <label>Max. Books Allowed to be Issued to Student </label>
            <label>Max. Books Allowed to be Issued to Teacher </label>
          </div>
          {/* Right Column - Inputs */}
          <div className="settings-inputs">
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="penaltyEnabled"
                  value="Yes"
                  checked={settings.penaltyEnabled === "Yes"}
                  onChange={handleChange}
                />
                Yes
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="penaltyEnabled"
                  value="No"
                  checked={settings.penaltyEnabled === "No"}
                  onChange={handleChange}
                />
                No
              </label>
            </div>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control detail"
              name="daysToReturn"
              value={settings.daysToReturn}
              onChange={handleChange}
            />
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control detail"
              name="penaltyPerDay"
              value={settings.penaltyPerDay}
              onChange={handleChange}
            />
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="sendMessageEnabled"
                  value="Yes"
                  checked={settings.sendMessageEnabled === "Yes"}
                  onChange={handleChange}
                />
                Yes
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="sendMessageEnabled"
                  value="No"
                  checked={settings.sendMessageEnabled === "No"}
                  onChange={handleChange}
                />
                No
              </label>
            </div>

            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control detail"
              name="daysPriorMessage"
              value={settings.daysPriorMessage}
              onChange={handleChange}
            />
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control detail"
              name="maxBooksStudent"
              value={settings.maxBooksStudent}
              onChange={handleChange}
            />
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control detail"
              name="maxBooksTeacher"
              value={settings.maxBooksTeacher}
              onChange={handleChange}
            />
          </div>
        </div>
        <button className="save-button" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default LibrarySettings;
